<template>
  <Container type="card-full" drankColor>
    <div class="main">
      <div class="box">
        <div class="l">
          <div class="item">
            <span class="filed">项目编号:</span><span class="filed1">{{ project.projectcode }}</span>
          </div>
          <div class="item">
            <span class="filed">项目名称:</span><span class="filed1">{{ project.projectname }}</span>
          </div>
          <div style="display: flex; aligin-items: center">
            <div class="item" v-if="+project.projectysflg === 1">
              <span class="filed">预算金额:</span>
              <span class="filed1 m-r-15">{{ project.projectlimitamt | qfwVal }} (
                <amount :money="String(project.projectlimitamt)" v-if="project.projectlimitamt" />)
              </span>
            </div>
            <div class="item">
              <span class="filed">报价含税:</span><span class="filed1">{{
                  +project.projecthsflg === 1 ? "含税" : "不含税"
              }}</span>
            </div>
          </div>
        </div>
        <div class="r">
          <div style="width: 280px">
            <div>
              <span class="filed">开始时间: </span><span class="filed1">{{
                  project.prsbjbegtime | newDateTime
              }}</span>
            </div>
            <div>
              <span class="filed time">当前时间: </span><span class="filed1 time">{{ sysDate }}</span>
            </div>
            <div>
              <span class="filed">截止时间: </span><span class="filed1">{{
                  project.prsbjendtime | newDateTime
              }}</span>
            </div>
          </div>
          <div class="btn">
            <el-button type="danger" size="medium" @click="quit" icon="el-icon-close">退出大厅</el-button>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="m-r-15">
          <span class="filed">项目员</span>
          <span class="filed1" v-if="project.projecttype === 2">{{ project.hostusercode | keepSecret }}
            <!-- {{ +msgList.isOnline >= 0 ? "[在线]" : "[不在线]" }} -->
          </span>
          <span class="filed1" v-else>{{ project.hostusercode | keepSecret }}
            <!-- {{ +msgList.isOnline >= 0 ? "[在线]" : "[不在线]" }} -->
          </span>
        </div>
        <div v-if="
          +project.projecttenderbidmode === 1 &&
          +project.projectopenbidmode === 2
        ">
          <!-- <el-button size="small" v-if="showCGbtn" :disabled="disabledB.showSpeak" class="m-r-15"  @click="showModeratorSpeaks">发言</el-button> -->
          <el-popover placement="top" width="300" trigger="manual" v-model="showfy">
            <p>请输入发言内容</p>
            <el-input style="margin: 0 0 20px 0" v-model="moderatorSpeaksMsg" placeholder="请输入内容"></el-input>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="showfy = false">取消</el-button>
              <el-button type="primary" size="mini" @click="moderatorSpeaks">确定</el-button>
            </div>
            <el-button type="primary" slot="reference" size="small" style="margin-right: 10px" class="m-r-15"
              v-if="showCGbtn" @click="showModeratorSpeaks" :disabled="disabledB.showSpeak">发言</el-button>
          </el-popover>
          <el-button type="primary" size="small" v-if="showCGbtn" :disabled="disabledB.showStartKB" class="m-r-15"
            @click="startKB">开始</el-button>
          <el-button type="primary" size="small" v-if="showCGbtn" :disabled="disabledB.showCheckTBFile" class="m-r-15"
            @click="checkTbFile">检查投标文件</el-button>
          <el-button type="primary" size="small" v-if="showCGbtn" :disabled="disabledB.showKBtnview" class="m-r-15"
            @click="showKBInfo">价格开标</el-button>
          <el-button type="primary" size="small" @click="KBview" :disabled="disabledB.showKBPrice">{{ bjviewName }}
          </el-button>
          <el-button type="primary" size="small" v-if="showCGbtn" :disabled="disabledB.showEndKB" class="m-r-15"
            @click="endKB">结束</el-button>
        </div>
        <div v-else>
          <el-button type="primary" size="small" v-if="showCGbtn" :disabled="disabledB.showStartKB" class="m-r-15"
            @click="startKB">开始</el-button>
          <el-button type="primary" size="small" v-if="showCGbtn" :disabled="disabledB.showEndKB" class="m-r-15"
            @click="endOfflineKB">结束</el-button>
        </div>
      </div>
      <div v-if="
        +project.projecttenderbidmode === 1 &&
        +project.projectopenbidmode === 2
      ">
        <!-- 线上投标，远程开标 -->
        <div class="desc-box content-box">
          <div class="l">
            <div class="bg-white txt">
              <i class="icon el-icon-s-custom"></i>
              <span>在线用户</span>
            </div>
            <div class="message-list bg-white">
              <div class="block">
                <span class="title">
                  <i class="icon el-icon-s-custom"></i> <span>代理人</span>
                </span>
                <div v-for="(item, index) in msgList.onLineUser.dlr" :key="index">
                  {{ item.usercode }}
                </div>
              </div>
              <div class="block">
                <span class="title">
                  <i class="icon el-icon-s-custom"></i> <span>采购人</span>
                </span>
                <div v-for="(item, index) in msgList.onLineUser.cgr" :key="index">
                  {{ item.usercode }}
                </div>
              </div>
              <div class="block">
                <span class="title"><i class="icon el-icon-s-custom"></i>
                  <span>供应商</span></span>
                <div v-for="(item, index) in msgList.onLineUser.gys" :key="index">
                  {{ item.usercode }}
                </div>
              </div>
            </div>
          </div>
          <div class="r">
            <div class="message-content bg-white" ref="msg-content" style="height: 370px; width: 100%; margin: 0 0">
              <div v-for="(item, index) in msgList.common" class="item" :key="index">
                {{ item.time }}: {{ item.msg }}
              </div>
            </div>
          </div>
        </div>
        <div class="box">
          <div>
            <span class="filed">开标必读:</span>
            <div v-html="cosInfo.coskbreadinfo"></div>
          </div>
        </div>
      </div>
      <div v-if="
        +project.projecttenderbidmode === 1 &&
        +project.projectopenbidmode === 1 &&
        showBox === true
      ">
        <!-- 线上投标，现场开标 -->
        <div class="box">
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="投标文件" name="first">
              <div class="b">
                <div class="b-header">
                  <div class="header-item">投标单位</div>
                  <div class="header-item">提交方式</div>
                  <div class="header-item">是否提交</div>
                </div>
                <div class="b-body-box">
                  <div class="b-body" v-for="(item, index) in this.psuList" :key="index">
                    <div class="body-item">{{ item.comfullname }}</div>
                    <div class="body-item">线上提交</div>
                    <div class="body-item">
                      {{ item.appendurl ? "是" : "否" }}
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="开标一览表" name="second">
              <div id="kbView">
                <div class="kb-top">开标一览表</div>
                <div class="kb-b">
                  <div class="b-l">项目名称：{{ project.projectname }}</div>
                  <div class="b-">项目编号：{{ project.projectcode }}</div>
                </div>
                <div class="kb-b">
                  <div class="b-l">开标地点：{{ project.projectbidaddr }}</div>
                  <div class="b-r">
                    开标时间：{{ project.projectjkactualbegtime | newDateTime }}
                  </div>
                </div>
                <div class="b-KBS">
                  <div class="b-header">
                    <div class="header-item">序号</div>
                    <div class="header-item">投标人名称</div>
                    <div class="header-item">投标报价（人民币/元）</div>
                    <div class="header-item">投标人代表签名</div>
                  </div>
                  <div class="b-body-box">
                    <div class="b-body" v-for="(item, index) in this.psuList" :key="item.psuid">
                      <div class="body-item">{{ index + 1 }}</div>
                      <div class="body-item">{{ item.comfullname }}</div>
                      <div class="body-item">
                        <span v-if="item.psuamt">￥{{ item.psuamt | qfwVal }}(
                          <amount :money="String(item.psuamt)" v-if="item.psuamt" />)
                        </span>
                      </div>
                      <div class="body-item" style="color: red">
                        {{ item.psuname }}
                        {{ item.psuamtcommittime | newDateTime }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="footer-f">
                  <div class="f-o">
                    <div class="f-o-l">采购人代表：</div>
                    <div class="f-o-r">监督人员：</div>
                  </div>
                </div>
                <div class="footer-f">
                  <div class="f-o">
                    <div class="f-o-l">记录员：</div>
                    <div class="f-o-r">唱标人：</div>
                  </div>
                </div>
              </div>
              <div class="button-box" v-if="showCGbtn">
                <el-button type="primary" class="b-button" @click="Export">打印</el-button>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div v-if="
        +project.projecttenderbidmode === 2 &&
        +project.projectopenbidmode === 1 &&
        showBox === true
      ">
        <!-- 线下投标，现场开标 -->
        <div class="kb-box" id="kb-box">
          <div class="kb-top">开标一览表</div>
          <div class="kb-b">
            <div class="b-l">项目名称：{{ project.projectname }}</div>
            <div class="b-">项目编号：{{ project.projectcode }}</div>
          </div>
          <div class="kb-b">
            <div class="b-l">开标地点：{{ project.projectbidaddr }}</div>
            <div class="b-r">
              开标时间：{{ project.projectjkactualbegtime | newDateTime }}
            </div>
          </div>
          <div class="b-KBS">
            <div class="b-header">
              <div class="header-item">序号</div>
              <div class="header-item">投标人名称</div>
              <div class="header-item">投标报价（人民币/元）</div>
              <div class="header-item">投标人代表签名</div>
            </div>
            <div class="b-body-box">
              <div class="b-body" v-for="(item, index) in this.psuList" :key="item.psuid">
                <div class="body-item">{{ index + 1 }}</div>
                <div class="body-item">{{ item.comfullname }}</div>
                <div class="body-item" @click="elInputClick(item)" v-if="!project.projectpriceopentime">
                  <el-input oninput="value=value.replace(/[^\d^\.]/g,'')" v-model="item.psuamt" v-focus ref="elInput"
                    placeholder="请输入价格" v-if="item.showElInput" @blur="closeInput(item)">
                  </el-input>
                  <span v-if="!item.showElInput && item.psuamt">
                    ￥{{ item.psuamt | qfwVal }}(
                    <amount :money="String(item.psuamt)" v-if="item.psuamt" />)
                  </span>
                </div>
                <div class="body-item" v-else>
                  <span v-if="item.psuamt">
                    ￥{{ item.psuamt | qfwVal }}(
                    <amount :money="String(item.psuamt)" v-if="item.psuamt" />)
                  </span>
                </div>
                <div class="body-item"></div>
              </div>
            </div>
          </div>
          <div class="footer-f">
            <div class="f-o">
              <div class="f-o-l">采购人代表：</div>
              <div class="f-o-r">监督人员：</div>
            </div>
          </div>
          <div class="footer-f">
            <div class="f-o">
              <div class="f-o-l">记录员：</div>
              <div class="f-o-r">唱标人：</div>
            </div>
          </div>
        </div>
        <div class="button-box" v-if="showCGbtn">
          <el-button type="primary" class="b-button" :disabled="btnCanclick"
            v-if="!btnCanclick && !this.project.projectpriceopentime" @click="savePsuamt">确认</el-button>
          <el-button type="primary" class="b-button" @click="ExportT" v-else>打印</el-button>
        </div>
      </div>
      <el-dialog title="开标一览表" :visible.sync="showKBview" width="80%" :before-close="handleClose" center>
        <div class="kb-box">
          <div class="kb-top">开标一览表</div>
          <div class="kb-b">
            <div class="b-l">项目名称：{{ project.projectname }}</div>
            <div class="b-">项目编号：{{ project.projectcode }}</div>
          </div>
          <div class="kb-b">
            <div class="b-l">开标地点：{{ project.projectbidaddr }}</div>
            <div class="b-r">
              开标时间：{{ project.projectjkactualbegtime | newDateTime }}
            </div>
          </div>
          <div class="b-KBS">
            <div class="b-header">
              <div class="header-item">序号</div>
              <div class="header-item">投标人名称</div>
              <div class="header-item">投标报价（人民币/元）</div>
              <div class="header-item">投标人代表签名</div>
            </div>
            <div class="b-body-box">
              <div class="b-body" v-for="(item, index) in this.psuList" :key="item.psuid">
                <div class="body-item">{{ index + 1 }}</div>
                <div class="body-item">{{ item.comfullname }}</div>
                <div class="body-item">
                  <span v-if="item.psuamt">￥{{ item.psuamt | qfwVal }}(
                    <amount :money="String(item.psuamt)" v-if="item.psuamt" />)
                  </span>
                </div>
                <div class="body-item">
                  <div v-if="
                    $store.getters.loginUser.comid == item.comid &&
                    !disabledB.savebtn
                  ">
                    <el-button type="primary" class="b-button" @click="confirmPsuInfo">确认</el-button>
                  </div>
                  <div v-else style="color: red">
                    <!-- <div
                      v-if="
                        +item.psuamtcommituserid &&
                        +item.psuamtcommituserid !== +item.psuuserid
                      "
                    >
                      系统自动确认
                    </div>
                    <div v-else> -->
                    {{ item.psuname }}
                    <!-- </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="footer-f">
            <div class="f-o">
              <div class="f-o-l">采购人代表：</div>
              <div class="f-o-r">监督人员：</div>
            </div>
          </div>
          <div class="footer-f">
            <div class="f-o">
              <div class="f-o-l">记录员：</div>
              <div class="f-o-r">唱标人：</div>
            </div>
          </div>
          <!-- <div>
                  <div class="button-box">
                    <el-button class="b-button" :disabled="disabledB.savebtn" v-if="this.$route.params.psuid" @click="confirmPsuInfo">确认</el-button>
                  </div>
              </div> -->
        </div>
      </el-dialog>
      <!-- <div>
        <el-dialog
          title="主持人发言"
          :visible.sync="showfy"
          width="70%">
            <div class="dialog">
                <div class="boxitem">
                  <div class="itemname">
                      请输入发言内容
                  </div>
                  <div class="itemcon">
                      <el-input v-model="moderatorSpeaksMsg" placeholder="请输入内容"></el-input>
                  </div>
                </div>
                <div class="boxitembtn">
                  <div class="itembtn">
                      <el-button @click="moderatorSpeaks">发送</el-button>
                  </div>
                </div>
            </div>
        </el-dialog>
      </div> -->
    </div>
  </Container>
</template>

<script>
import request from "@/utils/request";
import utils from "../../assets/js/utils";
import config from "../../assets/config";
import uploadBtn from "../common/uploadBtn";
import vggrid from "../common/vggrid";
import amount from "../common/amount";
import common from "@/mixin/common";
import io from "socket.io-client";
import moment from "moment";
import { getLodop } from "@/assets/js/LodopFuncs";
// import data from '../component/data'
import { mapGetters } from "vuex";
let LODOP;
// import { isFormData } from 'xe-utils/methods'
// import BetterScroll from 'better-scroll'
/* eslint-disable */
export default {
  name: "pbrTenderForm",
  mixins: [common],
  data() {
    return {
      showfy: false,
      project: {},
      cosInfo: {},
      psuid: this.$route.params.psuid,
      append: { appendurl: "", appendfilename: "" },
      msgList: {
        common: [],
        onLineUser: [],
      },
      showCGbtn: true,
      interval: null,
      timeInterval: null,
      days: "0",
      hours: "0",
      minutes: "0",
      seconds: "0",
      date: "",
      activeName: "first",
      psuList: [],
      showBox: false,
      btnCanclick: false,
      moderatorSpeaksMsg: "", //发言内容
      disabledB: {
        showSpeak: false,
        showStartKB: true,
        showCheckTBFile: true,
        showKBtnview: true,
        showKBPrice: true,
        showEndKB: true,
        savebtn: true,
      },
      psuNum: 0,
      showKBview: false,
    };
  },
  destroyed() {
    if (this.ispbrTenderFormClose === 3) {
      // this.$store.commit('close_tab', {routeName: this.$route.name, vm:this, newRouteName:''})
      this._clearData();
    }
  },
  async mounted() {
    this.getMypsuInfo();
    // setTimeout(() => {
    //   this._initScroll()
    // }, 300)
    this.$nextTick(async () => {
      // this._initScroll()
      // this.bs = new BetterScroll(this.$refs['msg-content'], {
      //   probeType: 3,
      //   y: 400,
      // })
      await this.init();
      await this.getProjectById();
      this.showBOX();
      await this.getPsuByprojectId(); //获取应到人数
      // if (moment(new Date()).isBefore(this.project.prsbjendtime)) {
      //   this.time()
      // } else {
      //    this.interval = null
      //    this.sokcet()
      //    this.fromEmit('系统提醒,正式报价开始了', 1)
      // }
      // if(+this.project.projecttenderbidmode === 1 && +this.project.projectopenbidmode === 2){
      this.sokcet();
      this.timeInterval = setInterval(() => {
        this.date && (this.date = new Date(this.date).getTime() + 1000);
      }, 1000);
      // }
      // this.ispbrTenderFormClose === 1 && this.$store.commit('SET_ISPBRTENDERFORMCLOSE', 0)
    });
    window.addEventListener("beforeunload", () => {
      this._clearData();
    });
    this.getBMList();
    this.getcositemList();
    this.getALLStatus();
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.querySelector("input").focus();
      },
    },
  },
  watch: {},
  filters: {
    newDateTime(val) {
      return utils.formatterDate(val, "yyyy-MM-dd HH:mm:ss");
    },
    formatComdify(value) {
      return utils.comdify(value);
    },
    keepSecret(num) {
      var mobile = String(num);
      var reg = /^(\d{3})\d{4}(\d{4})$/;
      return mobile.replace(reg, "$1****$2");
    },
    qfwVal(value) {
      if (!!value && +value > 0) {
        return utils.comdify(value);
      } else {
        return value;
      }
    },
  },
  components: { uploadBtn, amount, vggrid },
  computed: {
    ...mapGetters(["tabRoutes", "loginUser", "ispbrTenderFormClose"]),
    uploadAddr() {
      return this.$store.getters.uploadAddr;
    },
    dayNum() {
      if (this.days < 10) return "0" + this.days;
      return this.days;
    },
    hourNum() {
      if (this.hours < 10) return "0" + this.hours;
      return this.hours;
    },
    minuteNum() {
      if (this.minutes < 10) return "0" + this.minutes;
      return this.minutes;
    },
    secondNum() {
      if (this.seconds < 10) return "0" + this.seconds;
      return this.seconds;
    },
    sysDate() {
      return utils.formatterDate(new Date(this.date), "yyyy-MM-dd HH:mm:ss");
    },
    bjviewName() {
      if (this.$store.getters.loginUser.comtype === 3) {
        return "报价结果确认";
      } else {
        return "报价一览表";
      }
    },
  },
  methods: {
    _clearData() {
      this.socket.emit("quit", {
        id: this.loginUser.userid,
        usercode: this.loginUser.usercode,
        projectcode: this.project.projectcode,
        usertype: this.loginUser.comtype,
      });
      this.socket.on("disconnect", function () { });
      clearInterval(this.interval);
      this.interval = null;
      clearInterval(this.timeInterval);
      this.timeInterval = null;
      this.$store.commit("SET_ISPBRTENDERFORMCLOSE", 0);
    },
    fromOperate(m) {
      this.socket.emit("fromOperate", {
        id: this.loginUser.userid,
        projectcode: this.project.projectcode + "tender",
        operate: {
          projectcode: this.project.projectcode + "tender",
          m: m,
          type: "method",
        },
      });
    },
    // _initScroll () {
    //   this.bs = new BetterScroll(this.$refs['msg-content'], {
    //     probeType: 3
    //   })
    //   this.bs.on('scroll', (pos) => {
    //     console.log(pos)
    //   })
    // },
    quit() {
      this.$confirm("是否退出竞价大厅?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.commit("SET_ISPBRTENDERFORMCLOSE", 3);
          this.$store.commit("close_tab", {
            routeName: this.$route.name,
            vm: this,
            newRouteName: "",
          });
        })
        .catch(() => { });
    },
    async getProjectById() {
      let res = await request({
        method: "get",
        url: "/xmgl/project/getProjectById",
        params: { projectid: this.$route.params.projectid },
      });
      this.project = res[0];
    },
    time() {
      let that = this;
      this.interval = setInterval(() => {
        if (moment(this.project.prsbjendtime).isBefore(moment())) {
          clearInterval(that.interval);
          that.interval = null;
          this.sokcet();
          this.fromEmit("系统提醒,正式报价开始了");
        }
        let dur = moment.duration(
          moment(this.project.prsbjendtime) - moment(),
          "ms"
        );
        this.days = dur.get("days");
        this.hours = dur.get("hours");
        this.minutes = dur.get("minutes");
        this.seconds = dur.get("seconds");
      }, 1000);
    },
    sokcet() {
      if (!this.socket) this.socket = io(config.baseUrl);
      let obj = {
        id: this.loginUser.userid,
        usercode: this.loginUser.usercode,
        projectcode: this.project.projectcode + "tender",
        usertype: this.loginUser.comtype,
        isCloseStatus: this.ispbrTenderFormClose,
      };
      this.ispbrTenderFormClose === 2 && (obj.firstTime = moment(new Date()));
      this.socket.emit("onProject", obj);
      this.ispbrTenderFormClose === 1 &&
        this.socket.emit("getCacheMsg", {
          projectcode: this.project.projectcode,
          id: this.loginUser.userid,
        });
      this.socket.on("msg", (data) => {
        if (data.projectcode == this.project.projectcode + "tender") {
          if (data.common) {
            !this.msgList["common"] && (this.msgList["common"] = []);
            if (Array.isArray(data.common))
              this.msgList["common"] = data.common;
            else this.msgList["common"].unshift(data.common);
            // this.bs && this.bs.refresh()
            // this.bs.scrollToElement(this.$refs['test'])
            // this.$refs['msg-content'].scrollTo(0, 300)
          }
          if (data.lineUser) {
            this.msgList["onLineUser"] = data.lineUser;
            if (+this.project.projecttype === 2) {
              this.msgList.isOnline = data.lineUser.all.findIndex((item) => {
                return (
                  Number(item.userid) === Number(this.project.projectpuserid)
                );
              });
            } else {
              this.msgList.isOnline = data.lineUser.all.findIndex((item) => {
                return (
                  Number(item.userid) === Number(this.project.projectauserid)
                );
              });
            }
          }
          if (data.type === "method") {
            this[data.m] && this[data.m].bind(this)();
          }
        }
      });
    },
    async init() {
      this.project = {};
      this.append = { appendurl: "", appendfilename: "" };
      this.date = await request({
        method: "get",
        url: "xtgl/sysdata",
      });
      this.date = new Date(this.date).getTime();
      this.showBox = false;
      //代理||采购 显示按钮
      this.showCGbtn =
        +this.$store.getters.loginUser.comtype !== 3 ? true : false;
    },
    // 1 = 系统消息
    fromEmit(msg, type) {
      this.sokcet();
      this.socket.emit("fromEmit", {
        id: this.$store.getters.loginUser.userid,
        msg,
        type,
        projectcode: this.project.projectcode + "tender",
      });
    },
    close() {
      this.$store.commit("close_tab", {
        routeName: this.$route.name,
        vm: this,
        newRouteName: "projectPbrIndex",
      });
    },
    handleClick(tab, event) {
      this.getBMList();
    },
    async getcositemList() {
      this.loading = true;

      let res = await request({
        method: "get",
        url: "/ywgl/cos/getCosbyid",
        params: { cosid: this.$store.getters.loginUser.cosid },
      });

      this.cosInfo = res[0];

      this.loading = false;
    },
    async getBMList() {
      //获取所有报名信息
      this.loading = true;
      let res = await request({
        method: "get",
        url: "/xmgl/bidOpening/getBMList",
        params: { projectid: this.$route.params.projectid },
      });
      if (
        +this.project.projectpricelistflag === 0 &&
        +this.$store.getters.loginUser.comtype === 3
      ) {
        res = res.filter((e) => {
          return +e.psucomid === +this.$store.getters.loginUser.comid;
        });
      }
      if (
        this.project.projectjkactualendtime != null &&
        +this.project.projecttenderbidmode === 2
      ) {
        //项目结束后，线下开标的不显示没有报价的
        res = res.filter((e) => {
          return e.psuamt != "";
        });
      }
      if (!this.project.projectpriceopentime) {
        res.forEach((e) => {
          e.showElInput = true;
        });
      }
      this.psuList = res;
      this.loading = false;
    },
    async startKB() {
      this.loading = true;
      let data = await request({
        url: "/xmgl/pbr/startJJ",
        method: "post",
        data: this.project,
      });
      if (data.issuccess === 1) {
        this.showBOX();
        // this.fromOperate('getALLStatus')
        this.getALLStatus();
        if (
          +this.project.projecttenderbidmode === 1 &&
          +this.project.projectopenbidmode === 2
        ) {
          this.Speaks(`本项目采取远程开标方式，现在正式开始；
                          应到供应商${this.psuNum}人实到${this.msgList.onLineUser.gys.length}人；
                          采购人${this.msgList.onLineUser.cgr.length}人；
                          代理人${this.msgList.onLineUser.dlr.length}人。`);
        }
      }
      this.loading = false;
    },
    // 结束
    async endOfflineKB() {
      this.loading = true;

      this.$confirm(`是否结束开标`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let model = {};
          model.projectid = this.project.projectid;
          model.psuList = this.psuList;
          let data = await request({
            url: "/xmgl/bidOpening/endOfflineKB",
            method: "post",
            data: model,
          });
          if (data.issuccess === 1) {
            this.$message.success("开标结束");
            this.fromOperate("showBOX");
            // this.Speaks(`本项目网上竞价结束，各用户退出大厅，等候评审结果发布。` )
            this.fromOperate("getBMList");
            this.fromOperate("getALLStatus");
          } else {
            this.$message.error("失败");
          }
        })
        .catch(() => { });
      this.loading = false;
    },
    async endKB() {
      this.loading = true;
      let model = {};
      model.projectid = this.project.projectid;
      model.userid = this.loginUser.userid;

      let count = await request({
        url: "/xmgl/bidOpening/examination",
        method: "get",
        params: model,
      });

      this.$confirm(
        `还有${count[0].count}位供应商未确认，是否对他们就行确认`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          let data = await request({
            url: "/xmgl/bidOpening/endKB",
            method: "post",
            data: model,
          });
          if (data.issuccess === 1) {
            this.$message.success("开标结束");
            this.fromOperate("showBOX");
            // this.Speaks(`本项目网上竞价结束，各用户退出大厅，等候评审结果发布。` )
            this.fromOperate("getALLStatus");
          } else {
            this.$message.error("失败");
          }
        })
        .catch(() => { });
      this.loading = false;
    },
    Speaks(msg) {
      this.socket.emit("fromEmit", {
        id: this.loginUser.userid,
        projectcode: this.project.projectcode + "tender",
        msg: {
          projectcode: this.project.projectcode + "tender",
          common: {
            msg,
          },
        },
      });
    },
    async checkTbFile() {
      this.loading = true;

      let res = await request({
        url: "/xmgl/bidOpening/checkTbFile",
        method: "get",
        params: { projectid: this.project.projectid },
      });

      res.forEach((e) => {
        if (e.appendurl) {
          this.Speaks(`${e.comfullname}提交的投标文件齐全，已授权招标人阅读；`);
        } else {
          this.Speaks(`${e.comfullname}没有提交投标文件；`);
        }
      });

      this.disabledB.showCheckTBFile = true;
      this.disabledB.showKBtnview = false;
      this.loading = false;
    },
    async showKBInfo() {
      this.loading = true;

      await request({
        url: "/xmgl/bidOpening/pushPriceopentime",
        method: "post",
        data: { projectid: this.project.projectid },
      });

      let res = await request({
        url: "/xmgl/bidOpening/getPsuByprojectId",
        method: "get",
        params: { projectid: this.project.projectid },
      });

      this.Speaks(`项目投标${this.psuNum}家，实际报价${res.count.count}家;`);
      res.list.forEach((e) => {
        if (e.psuamt) {
          let capital = utils.smallToBig(String(e.psuamt));
          this.Speaks(
            `${e.comfullname}提交了报价，价格为：￥${e.psuamt}（${capital}）；`
          );
        } else {
          this.Speaks(`${e.comfullname}未提交报价；`);
        }
      });

      this.fromOperate("getALLStatus");

      this.loading = false;
    },
    //获取报名人数
    async getPsuByprojectId() {
      let res = await request({
        url: "/xmgl/pbr/getPsuByprojectId",
        method: "get",
        params: { projectid: this.project.projectid },
      });
      this.psuNum = res.count;
    },
    async showBOX() {
      await this.getProjectById();
      // this.disabledB.showStartKB = false
      // if(this.project.projectjkactualbegtime){
      //     this.showBox = true
      //     this.disabledB.showStartKB = true
      //     this.disabledB.showEndKB = false
      // }
      // if(this.project.projectjkactualendtime){
      //     this.showBox = false
      //     this.disabledB.showStartKB = true
      //     this.disabledB.showEndKB = true
      // }
    },
    elInputClick(item) {
      if (this.btnCanclick === false && !this.project.projectpriceopentime) {
        item.showElInput = true;
      }
    },
    closeInput(item) {
      item.showElInput = false;
    },
    async savePsuamt() {
      this.$confirm(`确认后，开标记录表将不允许再修改，是否确认`, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let confirmList = {};
          confirmList.psuList = this.psuList;
          confirmList.projectid = this.project.projectid;
          let res = await request({
            url: "/xmgl/bidOpening/savePsuamt",
            method: "post",
            data: confirmList,
          });
          if (res.issuccess === 1) {
            await this.getProjectById();
            await this.getBMList();
            this.btnCanclick = true;
            this.$message.success("保存成功");
          } else {
            this.$message.error("保存失败");
          }
        })
        .catch(() => { });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
    async confirmPsuInfo() {
      this.loading = true;
      let model = {};
      model.psuid = this.$route.params.psuid;
      model.psuamtcommituserid = this.$store.getters.loginUser.userid;

      let data = await request({
        url: "/xmgl/bidOpening/confirmPsuInfo",
        method: "post",
        data: model,
      });

      if (data.issuccess === 1) {
        this.$message.success("确认成功");
        this.showKBview = false;
        return;
      }

      this.loading = false;
    },
    async KBview() {
      this.loading = true;
      await this.getBMList();
      await this.getMypsuInfo();
      this.showKBview = true;
      this.loading = false;
    },
    async getALLStatus() {
      await this.getProjectById();
      await this.getBMList();
      let endbtn = false;
      // this.psuList.forEach(e => {
      //     if(e.psuamt !== null && e.psuamtcommituserid !== null){
      //         endbtn = true
      //     }
      // })
      //判断显示数据
      if (this.project.projectjkactualbegtime == null) {
        //开标未开始
        console.log("开标开始", this.project.projectjkactualbegtime);
        this.disabledB.showStartKB = false;
      }
      if (this.project.projectjkactualbegtime === null) {
        this.disabledB.showStartKB = false;
        this.disabledB.showCheckTBFile = true;
        this.disabledB.showKBtnview = true;
        this.disabledB.showEndKB = true;
        this.disabledB.savebtn = true;
      } else if (this.project.projectjkactualendtime) {
        this.disabledB.showStartKB = true;
        this.disabledB.showCheckTBFile = true;
        this.disabledB.showKBtnview = false;
        this.disabledB.showEndKB = true;
        this.disabledB.savebtn = true;
      }
      if (moment(new Date()).isBefore(this.project.prsbjbegtime)) {
        this.disabledB.showStartKB = true;
        this.disabledB.showCheckTBFile = true;
        this.disabledB.showKBtnview = true;
        this.disabledB.showEndKB = true;
        this.disabledB.savebtn = true;
      }
      if (moment(new Date()).isAfter(this.project.prsbjbegtime)) {
        this.disabledB.showStartKB = false;
        this.disabledB.showCheckTBFile = true;
        this.disabledB.showKBtnview = true;
        this.disabledB.showEndKB = true;
        this.disabledB.savebtn = true;
      }
      if (moment(new Date()).isAfter(this.project.prsbjendtime)) {
        this.disabledB.showStartKB = true;
        this.disabledB.showCheckTBFile = true;
        this.disabledB.showKBtnview = false;
        this.disabledB.showEndKB = true;
        this.disabledB.savebtn = true;
      }
      if (this.project.projectjkactualbegtime != null) {
        //开标开始
        console.log("开标开始", this.project.projectjkactualbegtime);
        this.disabledB.showStartKB = true;
        this.disabledB.showCheckTBFile = false;
        if (+this.project.projectopenbidmode === 1) {
          this.showBox = true;
          this.disabledB.showEndKB = false;
        }
        if (this.project.projectpriceopentime != null) {
          this.disabledB.showKBPrice = false;
          this.disabledB.showKBtnview = true;
          this.disabledB.showCheckTBFile = true;
          this.disabledB.showEndKB = false;
          this.btnCanclick = false;
        }
        // if(endbtn){
        //   this.disabledB.showEndKB = false
        // }
      }
      if (this.project.projectjkactualendtime != null) {
        //开标结束
        console.log("开标结束", this.project.projectpriceopentime);
        this.disabledB.showKBPrice = false;
        this.disabledB.showCheckTBFile = true;
        this.disabledB.showEndKB = true;
        if (+this.project.projectopenbidmode === 1) {
          this.showBox = true;
          this.btnCanclick = true;
        }
      }
    },
    async Export() {
      //线下投标，现场开标
      var style = document.createElement("link");
      style.href =
        "http://39.108.157.187:9600/upload/20201021/1603260125440.css";
      style.rel = "stylesheet";
      style.type = "text/css";
      document.getElementById("kbView").appendChild(style);
      LODOP = await getLodop();
      if (LODOP) {
        LODOP.SET_PRINT_STYLE("FontSize", 10);
        LODOP.ADD_PRINT_HTM(
          10,
          0,
          "90%",
          "80%",
          document.getElementById("kbView").innerHTML
        );
        LODOP.PREVIEW();
      }
    },
    async ExportT() {
      var style = document.createElement("link");
      style.href =
        "http://39.108.157.187:9600/upload/20201112/1605179095248.css";
      style.rel = "stylesheet";
      style.type = "text/css";
      document.getElementById("kb-box").appendChild(style);
      LODOP = await getLodop();
      if (LODOP) {
        LODOP.SET_PRINT_STYLE("FontSize", 10);
        LODOP.ADD_PRINT_HTM(
          10,
          0,
          "90%",
          "80%",
          document.getElementById("kb-box").innerHTML
        );
        LODOP.PREVIEW();
      }
    },
    async getMypsuInfo() {
      if (this.$route.params.psuid) {
        let res = await request({
          method: "get",
          url: "/xmgl/project/getpsubyid",
          params: { psuid: this.$route.params.psuid },
        });
        if (res[0].psuamtcommituserid) {
          this.disabledB.savebtn = true;
        } else {
          this.disabledB.savebtn = false;
        }
      }
    },
    //主持人发言
    async showModeratorSpeaks() {
      // this.showModeratorSpeaksflg = true
      console.log("=======sasda");

      this.showfy = true;
    },
    moderatorSpeaks() {
      this.socket.emit("fromEmit", {
        id: this.loginUser.userid,
        projectcode: this.project.projectcode + "tender",
        msg: {
          projectcode: this.project.projectcode + "tender",
          common: {
            msg: this.moderatorSpeaksMsg,
          },
        },
      });
      this.moderatorSpeaksMsg = "";
      // this.showModeratorSpeaksflg = false
      this.showfy = false;
    },
  },
};
</script>

<style scoped>
.main {
  font-size: 14px;
  color: #606266;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC,
    Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial,
    sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
}

.fliename {
  cursor: pointer;
  color: #2f74ff;
}

.box {
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  background-color: #fff;
  border-radius: 4px;
  margin-bottom: 5px;
  box-sizing: border-box;
  padding: 10px;
  color: #828282;
}

.box .l {
  flex: 1;
}

.box .r {
  width: 380px;
  text-align: right;
  display: flex;
  align-items: center;
}

.box .r .btn {
  flex: 1;
  margin-left: 20px;
}

.box .item {
  display: flex;
  align-items: center;
}

.filed,
.filed1 {
  font-size: 14px;
  line-height: 30px;
}

.filed {
  width: 70px;
}

.filed1 {
  flex: 1;
}

.m-r-15 {
  margin-right: 15px;
}

.tip {
  color: red;
  font-size: 14px;
  font-weight: bold;
}

.desc-box {
  display: flex;
  align-items: center;
  width: 100%;
  border-radius: 4px;
  margin-bottom: 5px;
  color: #828282;
}

.content-box {}

.content-box .l {
  display: flex;
  flex-direction: column;
  width: 235px;
  margin-right: 8px;
}

.content-box .r {
  flex: 1;
}

.desc-box .content {
  width: 60%;
  display: flex;
  align-items: center;
  margin: 0 5px;
  height: 70px;
  box-sizing: border-box;
  padding: 10px;
}

.desc-box .txt {
  height: 70px;
  text-align: center;
  line-height: 70px;
  margin-bottom: 7px;
}

.message-list {
  overflow: auto;
  height: 300px;
  box-sizing: border-box;
  padding: 15px;
}

.message-list .block {
  margin-bottom: 8px;
}

.message-list .title {
  color: #828282;
  font-weight: bold;
}

.message-list .item {
  color: #828282;
  font-size: 14px;
  margin-bottom: 4px;
}

.message-content {
  width: 60%;
  overflow: auto;
  height: 300px;
  margin: 0 5px;
  box-sizing: border-box;
  padding: 12px;
}

.message-content .item {
  color: #828282;
  font-size: 14px;
  margin-bottom: 5px;
  text-align: left;
}

.bg-white {
  background: #fff;
}

ul li {
  font-size: 14px;
  line-height: 32px;
}

.time {
  color: #232323;
  font-weight: bold;
}

.boxitem {
  display: flex;
  margin: 10px 10px;
}

.itemname {
  margin-right: 20px;
}

.boxitembtn {
  overflow: hidden;
}

.itembtn {
  float: right;
}

.el-tabs {
  width: 100%;
}

.kb-box {
  background-color: #fff;
}

.kb-top {
  text-align: center;
  font-weight: bolder;
  font-size: 20px;
  line-height: 40px;
}

.kb-b {
  display: flex;
  justify-content: space-between;
  padding: 10px 10px;
}

.b-l {}

.b-r {}

.b-KBS {
  border: 1px solid #e8eaec;
  text-align: center;
  background-color: #fff;
  /* color: #000; */
  margin-top: 10px;
}

.b {
  text-align: center;
  border: 1px solid #e8eaec;
}

.b-header {
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #e8eaec;
}

.header-item:first-child {
  flex: 1;
}

.header-item {
  flex: 3;
  line-height: 40px;
  background-color: #f8f8f9;
  border-right: 1px solid #e8eaec;
}

.header-item:last-child {
  border: 0;
}

.b-body-box {}

.b-body {
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #e8eaec;
}

.b-body:last-child {
  border: 0;
}

.body-item:first-child {
  flex: 1;
}

.body-item {
  flex: 3;
  /* line-height: 40px;
  height: 40px; */
  padding: 10px 0;
  border-right: 1px solid #e8eaec;
}

.body-item:last-child {
  border: 0;
}

.footer-f {
  /* margin-top: 20px; */
}

.footer-f:first-child {
  margin-top: 20px;
}

.f-o {
  display: flex;
  justify-content: space-around;
  padding: 20px 10px;
  line-height: 40px;
  height: 40px;
  /* border-bottom: 1px solid #e8eaec; */
}

.f-o:first-child {
  /* border-bottom: 1px solid #e8eaec; */
}

.f-o-l {
  flex: 1;
}

.f-o-r {
  flex: 1;
}

.button-box {
  display: flex;
  justify-content: center;
  background-color: #fff;
}

.b-button {
  margin: 20px auto;
  width: 200px;
}
</style>
